/* ==========================================================================
   Cura — Video Banner
   - Mute/unmute toggle for autoplay native videos
   - Mobile/desktop switching via CSS :has(); JS fallback for older browsers
   - Editor-safe re-init
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.cvbInit === 'true') return;
    root.dataset.cvbInit = 'true';

    /* ---- Mute / unmute buttons ---- */
    root.querySelectorAll('[data-cvb-mute]').forEach(function (btn) {
      var player = btn.closest('[data-cvb-native]');
      if (!player) return;
      var video = player.querySelector('video');
      if (!video) return;

      var iconOff = btn.querySelector('.cura-cvb__mute-icon--off');
      var iconOn  = btn.querySelector('.cura-cvb__mute-icon--on');

      function updateIcon() {
        if (iconOff) iconOff.hidden = !video.muted;
        if (iconOn)  iconOn.hidden  = video.muted;
      }

      btn.addEventListener('click', function () {
        video.muted = !video.muted;
        updateIcon();
      });

      updateIcon();
    });

    /* ---- JS fallback for mobile/desktop switching (no :has support) ---- */
    var hasMobile = !!root.querySelector('[data-cvb-mobile]');
    var desktop   = root.querySelector('[data-cvb-desktop]');
    var mobile    = root.querySelector('[data-cvb-mobile]');

    if (hasMobile && desktop && mobile) {
      function checkBreakpoint() {
        var isMobile = window.innerWidth < 750;
        desktop.style.display = isMobile ? 'none' : '';
        mobile.style.display  = isMobile ? '' : 'none';

        // Pause off-screen native videos, play visible ones
        [desktop, mobile].forEach(function (el) {
          var vid = el.querySelector('video');
          if (!vid) return;
          if (el.style.display === 'none') {
            vid.pause();
          } else if (vid.autoplay || vid.hasAttribute('autoplay')) {
            vid.play().catch(function () {});
          }
        });
      }

      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(checkBreakpoint, 100);
      });
      checkBreakpoint();
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-cura-video-banner]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-cura-video-banner]');
    if (root) {
      root.dataset.cvbInit = 'false';
      init(root);
    }
  });
})();